import { Observable, ObservableInput } from 'rxjs';
import { map } from 'rxjs/operators';

export class ActionResult<T> {
  private constructor(
    public isSuccess: boolean,
    public error?: string,
    public value?: T,
  ) {}

  static success<T>(value: T) {
    return new ActionResult<T>(true, null, value);
  }

  static failure<T>(error: string) {
    return new ActionResult<T>(false, error);
  }
}

export class CancelledResult {}

export function cancelledOfNoValue<T, O extends ObservableInput<any>>(): (
  source$: Observable<T>,
) => Observable<T | CancelledResult> {
  return (source$) =>
    source$.pipe(
      map((v) => {
        if (!v) {
          return new CancelledResult();
        }

        return v;
      }),
    );
}
